import { render, staticRenderFns } from "./vr_v2.vue?vue&type=template&id=a8322a1c&scoped=true&"
import script from "./vr_v2.vue?vue&type=script&lang=js&"
export * from "./vr_v2.vue?vue&type=script&lang=js&"
import style0 from "./vr_v2.vue?vue&type=style&index=0&id=a8322a1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8322a1c",
  null
  
)

export default component.exports